import React from 'react';
import { FormattedMessage } from 'react-intl';
import { HeadingMedium } from 'web-shared-components/components/StyledTypography';
import {
  StyledNotFoundWrapper,
  StyledNotFoundBackground,
  StyledNotFoundInfo,
  StyledNotFoundTitle,
  StyledPowerText,
  StyledNotFoundPhotograph,
} from 'web-shared-components/components/PortfolioTemplates/common/NotFound/Elements';
import notFoundBackground from '../../assets/not-found-background.jpg';

// Local copy of web-shared-components' NotFound: the packaged version hardcodes a
// drscdn photo URL that no longer resolves, so the background ships with the app instead.
const NotFound = () => (
  <StyledNotFoundWrapper>
    <StyledNotFoundBackground src={notFoundBackground} alt="Not found" />
    <StyledNotFoundInfo>
      <StyledNotFoundTitle>
        <FormattedMessage id="portfolio.not_found.oops" />
      </StyledNotFoundTitle>
      <HeadingMedium my="lg" bold>
        <FormattedMessage id="portfolio.not_found.description" />
      </HeadingMedium>
      <StyledPowerText>
        <FormattedMessage
          id="portfolio.not_found.power_by"
          values={{
            link: <a href="https://www.500px.com">500px</a>,
          }}
        />
      </StyledPowerText>
    </StyledNotFoundInfo>
    <StyledNotFoundPhotograph>
      <FormattedMessage
        id="portfolio.not_found.photo_by"
        values={{
          photographer: (
            <a
              style={{ color: 'inherit' }}
              href={`${process.env.REACT_APP_BASE_URL}/p/karenkhachaturov`}
            >
              Karen Khachaturov
            </a>
          ),
        }}
      />
    </StyledNotFoundPhotograph>
  </StyledNotFoundWrapper>
);

export default NotFound;
